import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';



const BreakevenPrices = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>
            
            <div id="main" className='warrant-sensitivity breakeven_sec Common_warrent'>
                <div id="maintable" style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                    <div style={{display: 'table-row'}}>
                    <div id="leftbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}} />
                    <div id="maincontainer" style={{display: 'table-cell', width: '100%'}}>
                        <div id="mainnav" className='first_table'>
                        <table style={{width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223'}}>
                            <tbody><tr>
                                <td width="20%" style={{textAlign: 'left', visibility: 'hidden'}}>
                                <table className="hasprev hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td width="33px"><div className="prev left" /></td>
                                        <td>
                                        <div className="prevlbl left">
                                            <div className="prevtitle " style={{textAlign: 'left'}} />
                                            <div className="prevname " style={{textAlign: 'left'}}>Warrant Sensitivity</div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                </td>
                                <td width="60%" style={{textAlign: 'center'}}>
                                <div id="pagetitlediv" style={{width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto'}}>
                                    <div id="ptitle" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px'}}>Useful Warrant terms</div>
                                    <div id="pname" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px'}}>Breakeven Price</div>
                                </div>
                                </td>
                                <td width="20%" style={{textAlign: 'right', visibility: 'hidden'}}>
                                <table className="hasnext  hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td>
                                        <div className="nextlbl right">
                                            <div className="nexttitle " style={{textAlign: 'right'}} />
                                            <div className="nextname " style={{textAlign: 'right'}}>Premium</div>
                                        </div>
                                        </td>
                                        <td width="33px"><div className="next right" /></td>
                                    </tr>
                                    </tbody></table>
                                </td>
                            </tr>
                            </tbody></table>
                        </div>
                        <div id="maincontent" style={{marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px'}}>
                        <div id="mainscroll" style={{height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px'}}>
                            <div id="mainscrollcontent">
                            <style dangerouslySetInnerHTML={{__html: "\n/*            .exampleholder .examplebox{\n                display:inline-block;\n                border:4px solid #404040;\n                background-color: #000000;\n                padding:16px;\n                width: 100%\n            }*/\n/*            .exampleholder .examplebox h3{\n                margin:0;\n                margin-bottom:16px;\n                font-weight: normal;\n            }*/\n            .exampleholder .examplebox .col{\n line-height: 1.42857143;\n                float:left;\n                width:50%;\n                min-width:280px;\n                margin:2px 0;\n            }\n            .exampleholder .examplebox .col .lbl,\n            .exampleholder .examplebox .col .val{\n                float:left;\n            }\n            .exampleholder .examplebox .col .lbl{\n                width:130px;\n                color:#8F8F8F;\n            }\n            .xs .exampleholder .examplebox .col .lbl,\n            .xxs .exampleholder .examplebox .col .lbl {\n                width:104px;\n            }\n            .formulaholder{\n                max-width:600px;\n            }            \n            .formulaholder .formulabox{\n                text-align:left;\n/*                background-color: #1F1F1F;*/\n                padding:1em;\n            }\n            .formulaholder .formulabox .leqt{\n                float: left;\n                padding-right: 5px;\n                padding-bottom:1em;\n            }\n            .formulaholder .formulabox .redtxt{\n                color:#FE3200;\n            } \n            .xs .formulaholder .formulabox,\n            .xxs .formulaholder .formulabox{\n             padding:0.5em;    \n            } \n            \n        " }} />
                            <div className="contentbox">
                                <p>
                                Calculation of the breakeven price is useful only if you were planning to hold the warrant till expiry, otherwise, breakeven is simply the price you bought the warrant at.<br /><br />
                                There are actually two ways to think about the breakeven price. If you’re not planning to hold the warrant until it expires, the breakeven price will be the price you paid for the warrant initially. If you are holding on to the warrant until it expires, the breakeven price is the price of the underlying share at expiry such that the warrant is at the same price you had purchased it for initially.<br /><br />
                                To understand how the breakeven price at expiry is calculated, let’s look at an example.
                                </p>
                                <div className="exampleholder">
                                <div className="examplebox">
                                    <h3 style={{color: "#fff"}}>Example:</h3>
                                    <div className="col"><div className="lbl">Type:</div><div className="val">Call Warrant (CW)</div></div>
                                    <div className="col"><div className="lbl">CW Price:</div><div className="val">MYR 0.15</div></div>
                                    <div className="col"><div className="lbl">Exercise Price:</div><div className="val">MYR 2.00</div></div>
                                    <div className="col"><div className="lbl">Underlying Price:</div><div className="val">MYR 2.30</div></div>
                                    <div className="col"><div className="lbl">Exercise Ratio:</div><div className="val">4</div></div>
                                </div>
                                </div>
                                <div className="formulaholder">
                                <div className="formulabox" style={{padding: "15px 15px 10px"}}>
                                    <div className="leqt">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td className="hltxt">Cost of buying the share via CW </td>
                                        </tr>
                                        </tbody>
                                    </table> 
                                    </div>
                                    <div className="reqt">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td>=&nbsp;</td><td style={{width: '317px'}}>(CW Price X Exercise Ratio) + Exercise Price</td>
                                        </tr>
                                        <tr>
                                            <td>=&nbsp;</td><td>(MYR 0.15 x 4) + MYR 2.00</td>
                                        </tr>
                                        <tr>
                                            <td>=&nbsp;</td><td>MYR 2.60</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                                </div>
                                <p>Let’s assume you are planning to hold this call warrant until its expiry date. The exercise price of the call warrant is MYR 2.00, the exercise ratio is 4. When you first purchased the call warrant, it was MYR 0.15 while the underlying share price was trading at MYR 2.30. The breakeven cost on expiry will be MYR 2.60.</p>
                                <div className="tipholder">
                                <div className="tipbox">
                                    <h2 style={{marginTop:'20px',}}>Helpful Tips on how to use breakeven</h2>
                                    <ul>
                                    <li><p>Another simple way to calculate breakeven is to look at premium (or time value). Premium represents the amount that the underlying share has to increase by in order for the warrants to be at breakeven at expiry. This will be explained in further detail in the next section.</p></li>
                                    <li><p>Remember that the breakeven price is the price that the share needs to reach AT EXPIRY for the warrant to equal the same price that you paid to purchase the warrant. The breakeven price for time periods before expiry will be lower. </p></li>
                                    <li><p>Warrant sensitivity is important for short term day traders and investors interested in the small/short term movements in a warrant. For all other investors, delta is likely to be more useful.</p></li>
                                    <li><p>You can view the breakeven for all warrants via the <Link target="_blank" to="/tools/warrantterms">Warrant Terms</Link> page.</p></li>
                                    </ul>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                        </div>
                        </div>
                    </div>
                    <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                    </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
                >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                    display: "table",
                    width: "100%",
                    textAlign: "center",
                    color: "#8F8F8F",
                    fontSize: "11px",
                    lineHeight: "40px",
                    }}
                >
                 <div className='copyright_sec'>
                    Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                    reserved.
                 </div>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    right: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasnext"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td>
                            <div className="nextlbl right">
                            <div
                                className="nextname "
                                style={{ textAlign: "right", fontSize: "15px" }}
                            >
                                <Link to="/edu/useful-warrant-terms/premium">
                                Premium
                                </Link>
                            </div>
                            </div>
                        </td>
                        <td width="33px">
                        <Link to="/edu/useful-warrant-terms/premium">
                            <div className="next right" />
                        </Link>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    left: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasprev"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td width="33px">
                        <Link to="/edu/useful-warrant-terms/warrant-sensitivity">
                            <div className="prev left" />
                        </Link>
                        </td>
                        <td>
                            <div className="prevlbl left">
                            <div
                                className="prevname "
                                style={{ textAlign: "left", fontSize: "15px" }}
                            >
                                <Link to="/edu/useful-warrant-terms/warrant-sensitivity">
                                    Warrant Sensitivity
                                </Link>
                            </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
            {/* <div className="dbtn dbtn-seminarbtn">
            <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
      );
}
export default BreakevenPrices;